<template>
  <div>
    <div class="event-table">
      <el-table :data="event_data" height='320px' size="mini"
        :header-cell-style="{ background: '#343434', color: '#c7c7c9', border: '1px solid #343434' }"
        style="width: 100%">
        <el-table-column prop="type" align="center" label="事件类型" width="120">
        </el-table-column>
        <el-table-column prop="timestamp" align="center" :formatter="timestampToTime" label="发生时间" width="200">
        </el-table-column>
        <el-table-column prop="objectName" align="center" label="对象">
        </el-table-column>
        <el-table-column prop="objectType" align="center" width="150" label="对象类型">
          <template slot-scope="scope">
            <span v-if="scope.row.objectType === 'folder'">文件夹</span>
            <span v-if="scope.row.objectType === 'stateChange'">状态变化</span>
            <span v-if="scope.row.objectType === 'AnalogOutput'">模拟量输出</span>
            <span v-if="scope.row.objectType === 'AnalogInput'">模拟量输入</span>
            <span v-if="scope.row.objectType === 'objectTransfer'">对象传输</span>
            <span v-if="scope.row.objectType === 'timeEventList'">时间事件-列表</span>
            <span v-if="scope.row.objectType === 'timeEvent'">时间事件-对象</span>
            <span v-if="scope.row.objectType === 'BinaryOutput'">数字量输出</span>
            <span v-if="scope.row.objectType === 'BinaryInput'">数字量输入</span>
            <span v-if="scope.row.objectType === 'value_String'">值-字符串</span>
            <span v-if="scope.row.objectType === 'value_Binary'">值-二进制</span>
            <span v-if="scope.row.objectType === 'value_Multistate'">值-多态</span>
            <span v-if="scope.row.objectType === 'value_Analog'">值-模拟量</span>
            <span v-if="scope.row.objectType === 'alarmControl'">报警控制</span>
            <span v-if="scope.row.objectType === 'userGroupAlarm'">用户组-报警</span>
            <span v-if="scope.row.objectType === 'group'">用户组</span>
            <span v-if="scope.row.objectType === 'user'">用户</span>
            <span v-if="scope.row.objectType === 'timeChart'">时间表-本地</span>
            <span v-if="scope.row.objectType === 'onlineChart'">曲线图-实时</span>
            <span v-if="scope.row.objectType === 'subDevice'">子设备</span>
            <span v-if="scope.row.objectType === 'device'">设备</span>
            <span v-if="scope.row.objectType === 'deviceGroup'">设备组</span>
            <span v-if="scope.row.objectType === 'logicalGroup'">逻辑组</span>
            <span v-if="scope.row.objectType === 'server'">服务器</span>
            <span v-if="scope.row.objectType === 'project'">项目</span>
          </template>
        </el-table-column>
        <el-table-column prop="userName" align="center" label="操作用户" width="120">
        </el-table-column>
        <el-table-column prop="description" align="center" label="事件描述" width="220">
        </el-table-column>
        <el-table-column prop="alarmStatus" align="center" label="报警状态" width="120">
        </el-table-column>
        <el-table-column prop="operateType" align="center" label="操作类型" width="120">
        </el-table-column>
      </el-table>
    </div>
    <!--事件列表的右键菜单-->
    <Menu ref="event_context_menu" :duration="1000" @itemClick="tree_menuItemClick">
      <MenuItem text="显示报警" iconCls="icon-showAlarm">
      </MenuItem>
      <MenuItem text="显示命令" iconCls="icon-showCommand">
      </MenuItem>
      <MenuItem text="显示趋势日志" iconCls="icon-showLog">
      </MenuItem>
      <Menu-sep />
      <MenuItem text="所有事件" iconCls="icon-allEvents">
      </MenuItem>
      <MenuItem text="事件过滤" iconCls="icon-eventFilter">
      </MenuItem>
      <Menu-sep />
      <MenuItem text="查找..." iconCls="icon-search">
      </MenuItem>
      <Menu-sep />
      <MenuItem text="刷新" iconCls="icon-reflash">
      <div align="right" style="font-size: 12px">F5</div>
      </MenuItem>
    </Menu>
    <div class="pagination-box">
      <!--<gs-pagination
        ref="pagination"
        :current="1"
        :before-jump="page => beforeJump(page)"
        :total="total"
        :page-size="params.pageSize"
        class="gs-pagination"
        @page-change="pageChange"
      />-->
      <el-pagination :page-size="params.pageSize" :current-page="params.pageNum" :pager-count="count"
        @current-change="pageChange" layout="prev, pager, next" :page-count="pagesd">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import service from '../../service/alarmService.js'
import leftService from '../../service/leftService'
import timeExchange from '../../utils/timestampToFormat.js'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      serachDataList: {
        "pageSize": 50,  // 每页显示条数
        "pageNum": 1, // 页数
        "startTime": null, // 开始时间
        "endTime": null, // 结束时间
        "sortField": "timestamp", // 排序字段 ，固定的，只有这一个，不可为空
        "sortOrder": "desc",// 排序类型（正序还是倒序） ，不可为空
        "queryFields": {
          "userName": '', // 操作用户
          "objectType": '', // 对象类型
          "objectName": '', // 对象
          "operateType": '',// 操作类型
          "points": '',// 报警状态
          "description": '',// 事件描述
        }
      },
      value: '',
      searchData: '',
      count: 11,
      pagesd: 0,
      params: {
        pageSize: 50,
        pageNum: 1,
        sortField: 'timestamp',
        sortOrder: 'desc'
      },
      loading: true,
      total: 0,
      pages: 0,
      event_data: [],
      showList: [],
      timeExchange: timeExchange,
      timer: null,
      bottom_height: `${(document.documentElement.clientHeight - 100) * 0.5 - 85}`
    }
  },
  computed: {
    ...mapState({
      loginStatus: 'loginStatus'
    })
  },
  watch: {
    loginStatus() {
      if (!this.loginStatus) {
        clearInterval(this.timer)
      }
    },
    '$store.state.eventArray'(newval, olval) {
      this.event_data = newval
    }
  },
  mounted() {
    clearInterval(this.timer)
    service.getEventList(this.params).then(res => {
      this.pagesd = res.pages
      this.total = res.total
      this.event_data = res.data
      this.$store.state.eventNum = res.total
      this.loading = false
    }).catch(err => {
      console.log(err)
      //  this.$Message.error(err.message)
      clearInterval(this.timer)
    })
    /*this.timer = setInterval(() => {
      service.getEventList(this.params).then(res => {
        this.total = res.total
        this.event_data = res.data
        this.$store.state.eventNum = res.total
        this.loading = false
      }).catch(err => {
        this.$Message.error(err.message)
        clearInterval(this.timer)
      })
    }, 1000)*/
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    timestampToTime(row, column) {
      var date = new Date(row.timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = date.getDate() + ' '
      var h = date.getHours() + ':'
      var m = date.getMinutes() + ':'
      var s = date.getSeconds()
      return Y + M + D + h + m + s
    },
    sorter(field1, field2) {
      return null
    },
    tree_menuItemClick() {

    },
    beforeJump(page, pagination = 'pagination') {
      if (isNaN(page) || page < 1 || page > this.$refs[pagination].totalPage) {
        this.$Message.error('请输入正确页数')
        return false
      }
    },
    pageChange(pageNum) {
      this.params.pageNum = pageNum
      this.serachDataList.pageNum = pageNum
      /* service.getEventList(this.params).then(res => {
        this.total = res.total
        this.event_data = res.data
        this.loading = false
      }) */
      leftService.searchEvent(this.serachDataList).then(res => {
        this.total = res.total
        this.event_data = res.data
        this.loading = false
      })
    },
    acknowledgeAlarm(row, event) {
      // row.state = 'Acknowledged'
      // service.acknowledgeAlarm(row).then(res => {
      //   alert(JSON.stringify(res))
      // })
    },
    event_right_click(event) {
      this.$refs.event_context_menu.showContextMenu(event.originalEvent.x, event.originalEvent.y)
    },
    sortChange(sorts) {
      this.params.sortField = sorts[0].field
      this.params.sortOrder = sorts[0].order
      this.pageChange(this.params.pageNum)
    },
    searchList(val) {
      this.serachDataList = val
      leftService.searchEvent(this.serachDataList).then(res => {
        this.pagesd = res.pages
        this.total = res.total
        this.event_data = res.data
      })
    }
    // showTime (row, column) {
    //   alert(column)
    // }
  }
}
</script>
<style lang='scss'>
.event-table {
  width: 100%;
}

.pagination-box {
  min-width: 620px;
  float: right;

  .gs-pagination {
    margin-bottom: 16px;
  }
}

// #rMenu {
//   position:absolute;
//   visibility:hidden;
//   top:0;
//   background-color: #fff;
//   text-align: left;
//   padding: 2px;
//   border: 1px solid #DFDFDF;
//   font-size: 14px;
// }
// .right-menu-li{

// 	margin: 1px 0;
// 	padding: 5px 15px 5px 10px;
// 	cursor: pointer;
// 	list-style: none outside none;
// 	background-color: #fff;
//   border-bottom: 1px solid #DFDFDF;
// }</style>



// WEBPACK FOOTER //
// src/components/alarm/eventList.vue